const wrapper = "_086w1ft1vvb";

export { wrapper };
import "./print.footer.style.linaria.module.css";
//# sourceMappingURL=print.footer.style.js.map
